import React from "react";
import HomeTemplate from "../components/templates/HomeTemplate";

const HomePage = () => {
    return(
        <HomeTemplate/>
    );
};

export default HomePage;